export default "__VITE_ASSET__51fb7f88__"